// extracted by mini-css-extract-plugin
module.exports = {"content":"StaticPage_content__OdSMy"};